import React, { useReducer, useEffect, createContext, useState } from 'react'
import { pageReducer, getActiveDeviceList, getTurnCred } from "./Service";
import { FaSync, FaMicroscope } from "react-icons/fa";

export const ActiveDeviceList = (props) => {
    const initialState = {
        activeDeviceList: [],
    }

    const [pageState, dispatch] = useReducer(pageReducer, initialState)
    const [isSearching, setIsSearching] = useState(true)
    const activeRoomName = sessionStorage.getItem('activeroomname')
    const filteredActiveDevicelist = pageState.activeDeviceList.filter(device => device != activeRoomName) // eslint-disable-line eqeqeq

    useEffect(() => {
        // Initial fetch
        getActiveDeviceList(dispatch)
        // Poll every 5 seconds
        const interval = setInterval(() => {
            getActiveDeviceList(dispatch)
        }, 5000)
        // Stop "searching" animation after 3 seconds
        const timer = setTimeout(() => setIsSearching(false), 3000)
        return () => { clearInterval(interval); clearTimeout(timer) }
    }, [])

    // Update searching state when list changes
    useEffect(() => {
        if (pageState.activeDeviceList.length > 0) {
            setIsSearching(false)
        }
    }, [pageState.activeDeviceList])

    const handleRefresh = () => {
        setIsSearching(true)
        getActiveDeviceList(dispatch)
        setTimeout(() => setIsSearching(false), 2000)
    }

    const handleOnClick = async (item) => {
        const response = await getTurnCred();
        const { turn_cred: { password, turn_url, user } } = response.data
        sessionStorage.setItem('password', password);
        sessionStorage.setItem('turn_url', turn_url);
        sessionStorage.setItem('user', user);
        sessionStorage.setItem('devicename', item.devicename);
        sessionStorage.setItem('roomname', item.roomname);
        window.location.reload(true)
    }

    return (
        <div style={{ padding: '16px 0' }}>
            {/* Header with refresh */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#374151' }}>
                    <FaMicroscope style={{ marginRight: '6px', color: '#6347D3' }} />
                    Available Devices
                </span>
                <button onClick={handleRefresh} style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    background: 'transparent', border: '1px solid #E5E7EB', borderRadius: '6px',
                    padding: '4px 12px', fontSize: '12px', color: '#6B7280', cursor: 'pointer'
                }}>
                    <FaSync style={{ animation: isSearching ? 'spin 1s linear infinite' : 'none', fontSize: '10px' }} />
                    {isSearching ? 'Scanning...' : 'Refresh'}
                </button>
            </div>

            {/* Device list */}
            {pageState.activeDeviceList.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {filteredActiveDevicelist.map((item) => (
                        <div key={item.roomname} onClick={() => handleOnClick(item)} style={{
                            display: 'flex', alignItems: 'center', gap: '10px',
                            padding: '10px 14px', borderRadius: '8px', cursor: 'pointer',
                            border: '1px solid #E5E7EB', background: '#fff',
                            transition: 'all 0.15s'
                        }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#6347D3'; e.currentTarget.style.background = '#F9F8FE' }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.background = '#fff' }}
                        >
                            <div style={{
                                width: '8px', height: '8px', borderRadius: '50%',
                                background: '#22C55E', flexShrink: 0
                            }} />
                            <span style={{ fontSize: '14px', fontWeight: 500, color: '#6347D3' }}>
                                {item.devicename}
                            </span>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: '24px 16px', color: '#9CA3AF', fontSize: '13px' }}>
                    {isSearching ? (
                        <span>Scanning for devices...</span>
                    ) : (
                        <span>No devices found. Make sure your microscope is connected and registered.</span>
                    )}
                </div>
            )}
        </div>
    )
}

export const PageContext = createContext(null)
